import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_arrow_left.svg'


const _hoisted_1 = { class: "flex flex-col h-full relative" }
const _hoisted_2 = { class: "px-5 py-4 border-b border-gray-lp-1400" }
const _hoisted_3 = {
  key: 0,
  class: "flex items-center gap-x-3"
}
const _hoisted_4 = { class: "text-black-lp-200 font-semibold text-xl" }
const _hoisted_5 = {
  key: 1,
  class: "text-black-lp-200 font-semibold text-xl"
}
const _hoisted_6 = { class: "bg-gray-lp-1000 flex-col h-full px-4 py-2.5 overflow-auto w-full" }
const _hoisted_7 = { class: "flex flex-row gap-3" }
const _hoisted_8 = { class: "pl-2.5 py-2 space-y-2" }
const _hoisted_9 = { class: "pl-2.5 py-2 space-y-2" }
const _hoisted_10 = { class: "w-full h-25" }
const _hoisted_11 = { class: "pt-4 w-full inline-block relative" }
const _hoisted_12 = { class: "pt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_TimeRangePicker = _resolveComponent("TimeRangePicker")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_custom_dropdown = _resolveComponent("custom-dropdown")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_Card = _resolveComponent("Card")!
  const _component_FormInvoiceDetail = _resolveComponent("FormInvoiceDetail")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("section", _hoisted_2, [
      (_ctx.routerId)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("img", {
              src: _imports_0,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
              class: "w-6 mr-1 cursor-pointer",
              alt: "back"
            }),
            _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("tagihan.editTitle")) + " - " + _toDisplayString(_ctx.detailData.header.invoiceNo), 1)
          ]))
        : (_openBlock(), _createBlock("h1", _hoisted_5, _toDisplayString(_ctx.$t("tagihan.createTitle")), 1))
    ]),
    _createVNode("section", _hoisted_6, [
      _createVNode(_component_Card, {
        rounded: "xl",
        class: "flex flex-col px-3 pt-3 pb-1.5",
        isShadow: false
      }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('tagihan.create.selectCustomer'),
              class: "w-2/5"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CustomDropdown, {
                  options: _ctx.refTypeList,
                  onSelect: _ctx.onChangeRefType,
                  placeholder: _ctx.$t('tagihan.create.selectCustomer'),
                  class: "mt-2 w-full",
                  isCustomWidth: "",
                  selectedItem: _ctx.refType
                }, null, 8, ["options", "onSelect", "placeholder", "selectedItem"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('no_data'),
              customClass: 'text-white w-4/5'
            }, {
              default: _withCtx(() => [
                (_ctx.refType.value === 'sender')
                  ? (_openBlock(), _createBlock(_component_SelectSearch, {
                      key: 0,
                      class: "mt-2",
                      onFocus: _ctx.fetchCustomerList,
                      onFilter: _cache[2] || (_cache[2] = (keyword) => _ctx.onChangeCustomerName(keyword)),
                      onClear: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onChangeCustomerName(''))),
                      isLoading: _ctx.isLoadingCustomerList,
                      options: _ctx.getDataCustomerList,
                      keyName: "name",
                      keyValue: "id",
                      placeholder: _ctx.$t('tagihan.create.namePlaceholder'),
                      modelValue: _ctx.selectedCustomer,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedCustomer = $event)),
                      onClose: _ctx.onCloseSearchCustomerList
                    }, null, 8, ["onFocus", "isLoading", "options", "placeholder", "modelValue", "onClose"]))
                  : (_openBlock(), _createBlock(_component_SelectSearch, {
                      key: 1,
                      class: "mt-2",
                      onFocus: _ctx.fetchClientList,
                      onFilter: _cache[5] || (_cache[5] = (keyword) => _ctx.onChangeClientName(keyword)),
                      onClear: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onChangeClientName(''))),
                      isLoading: _ctx.isLaodingClientList,
                      options: _ctx.getDataClientList,
                      keyName: "name",
                      keyValue: "id",
                      placeholder: _ctx.$t('tagihan.create.namePlaceholder'),
                      modelValue: _ctx.selectedCustomer,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectedCustomer = $event)),
                      onClose: _ctx.onCloseSearchCustomerList
                    }, null, 8, ["onFocus", "isLoading", "options", "placeholder", "modelValue", "onClose"]))
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('Tanggal Booking'),
              class: "w-full"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_TimeRangePicker, {
                  class: "mt-2 mr-4",
                  onSelect: _ctx.setPeriode,
                  isCloseDateAfterSelect: "",
                  placeholder: _ctx.$t('tagihan.create.datePlaceholder'),
                  default: _ctx.$t('custom'),
                  highlightOnSelected: true,
                  customCalendar: true,
                  customTotalMaxDate: 30,
                  resetLimitOnSetOption: "",
                  isDateAlignCenter: "",
                  maxDate: new Date(),
                  isSetMaxDate: "",
                  ref: "rangePicker"
                }, null, 8, ["onSelect", "placeholder", "default", "maxDate"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('tagihan.create.sttType'),
              class: "flex flex-col w-3/5"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_custom_dropdown, {
                  class: "mt-1.5",
                  placeholder: _ctx.$t('tagihan.create.sttTypePlaceholder'),
                  value: 
                _ctx.sttType.length
                  ? `${_ctx.sttType.length} ${_ctx.$t('tagihan.create.sttType')}`
                  : ''
              
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_8, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tipeSttOptions, (stt, index) => {
                        return (_openBlock(), _createBlock("div", {
                          key: index,
                          class: "p-field-checkbox mt-1"
                        }, [
                          _createVNode(_component_Checkbox, {
                            name: "suffix",
                            id: index,
                            value: stt.value,
                            modelValue: _ctx.sttType,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.sttType = $event))
                          }, null, 8, ["id", "value", "modelValue"]),
                          _createVNode("label", {
                            for: index,
                            class: "ml-2.5"
                          }, _toDisplayString(stt.name), 9, ["for"])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }, 8, ["placeholder", "value"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('tagihan.create.serviceType'),
              class: "w-3/5 mb-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_custom_dropdown, {
                  class: "mt-1.5",
                  placeholder: _ctx.$t('tagihan.create.serviceTypePlaceholder'),
                  value: 
                _ctx.serviceType.length
                  ? `${_ctx.serviceType.length} ${_ctx.$t('tagihan.create.service')}`
                  : ''
              
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_9, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tipeLayananOptions, (layanan, index) => {
                        return (_openBlock(), _createBlock("div", {
                          key: index,
                          class: "p-field-checkbox mt-1"
                        }, [
                          _createVNode(_component_Checkbox, {
                            name: "suffix",
                            id: index,
                            value: layanan.value,
                            modelValue: _ctx.serviceType,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.serviceType = $event))
                          }, null, 8, ["id", "value", "modelValue"]),
                          _createVNode("label", {
                            for: index,
                            class: "ml-2.5"
                          }, _toDisplayString(layanan.name), 9, ["for"])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }, 8, ["placeholder", "value"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('tagihan.create.sttNo'),
            optional: "",
            class: "w-full pt-6 text-12px xxl:text-14px"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.setErrorList) + " " + _toDisplayString(_ctx.clearSttListValue()) + " ", 1),
              _createVNode("div", _hoisted_10, [
                _createVNode("div", _hoisted_11, [
                  _createVNode(_component_multiselect, {
                    modelValue: _ctx.sttListValue,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.sttListValue = $event)),
                    placeholder: _ctx.$t('tagihan.create.sttInputPlaceholder'),
                    "tag-placeholder": "Press enter to add No. STT",
                    label: "name",
                    "track-by": "id",
                    options: _ctx.sttManualList,
                    multiple: true,
                    searchable: true,
                    taggable: true,
                    "preserve-search": true,
                    maxLength: 50,
                    "open-direction": "below",
                    isTextArea: "",
                    onKeyup: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onSearch($event))),
                    isError: _ctx.isError,
                    height: "100"
                  }, null, 8, ["modelValue", "placeholder", "options", "isError"])
                ]),
                _withDirectives(_createVNode("div", { class: "mt-4 text-red-lp-100 text-12px xxl:text-14px" }, _toDisplayString(_ctx.errorMessageLength) + "/" + _toDisplayString(_ctx.sttListValue.length) + " Data stt tidak ditemukan ", 513), [
                  [_vShow, _ctx.isError]
                ])
              ]),
              _createVNode("div", _hoisted_12, [
                _createVNode(_component_button_fill, {
                  custom: "bg-white px-12 border border-red-lp-100 text-white mr-4 w-full",
                  title: _ctx.$t('tagihan.create.add'),
                  isDisabled: !_ctx.isValid,
                  onClick: _ctx.onGenerate
                }, null, 8, ["title", "isDisabled", "onClick"])
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }),
      (_ctx.isFormDetail)
        ? (_openBlock(), _createBlock(_component_FormInvoiceDetail, {
            key: 0,
            shipmentData: _ctx.detailPreviewData,
            header: _ctx.detailData.header
          }, null, 8, ["shipmentData", "header"]))
        : _createCommentVNode("", true)
    ])
  ]))
}